import { useInternalRouter } from "@/common/stores/internalRouter";
import { PropsWithChildren, useEffect } from "react";
import { useLocation } from "react-router-dom";

const InternalRouter = ({ children }: PropsWithChildren) => {
  const { addPath, clearPaths } = useInternalRouter();

  const location = useLocation();

  useEffect(() => {
    if (location.pathname.split('/').filter(pathname => pathname).length <= 1) {
      clearPaths();
    }

    addPath({
      pathname: location.pathname,
      search: location.search,
    });
  }, [location.pathname, location.search]);

  return children;
}

export default InternalRouter;
